import { buttonBaseStyle, buttonDangerStyle, buttonOutlineStyle, buttonPrimaryStyle, buttonSecondaryStyle, buttonSideBarStyle } from '../../form/button';
export const Button = {
    sizes: {
        sm: {
            h: 7,
            px: 3,
            py: '0px'
        },
        md: {
            h: 9,
            px: 3.5
        },
        lg: {
            px: 4
        }
    },
    variants: {
        primary: buttonPrimaryStyle,
        secondary: buttonSecondaryStyle,
        base: buttonBaseStyle,
        outline: buttonOutlineStyle,
        sideBar: buttonSideBarStyle,
        danger: buttonDangerStyle
    },
    defaultProps: {
        variant: 'outline',
        size: 'md'
    }
};
